import { createApp } from './main.js'

const start = async () => {
  const ssrState = window.__INITIAL_STATE__ || {}
  delete window.__INITIAL_STATE__
  const { app, router } = await createApp({ ssrState })
  await router.isReady()
  app.mount('#app', true)
}

start()
